import { ModalContent } from '@porterin/feature/src/shared/lead-flow/view/view-model/LeadFlowVm';
import { ModalControl } from '@porterin/feature/src/shared/modal/domain/entities/ModalEntities';
import NextImageV2 from '@porterin/feature/src/ui/components/NextImageV2';
import React from 'react';

import { VehicleModalData } from '../../types';
import styles from '../styles/VehicleModalLayout.module.scss';

import VehicleDetailsCmp from './VehicleDetailsCmp';

interface VehicleModalLayoutCmpProps {
  children: React.ReactNode;
  modal: ModalControl;
  vehicle: VehicleModalData | undefined;
  modal_content: ModalContent;
}

function VehicleModalLayoutCmp({
  children,
  modal,
  vehicle,
  modal_content,
}: Readonly<VehicleModalLayoutCmpProps>): React.ReactElement {
  return (
    <div className={styles['estimate-layout-container']}>
      {vehicle ? (
        <VehicleDetailsCmp vehicle={vehicle} title={modal_content.title} />
      ) : (
        <section className={styles['title-container']}>
          <p className={styles['title-mobile']}>{modal_content.title}</p>
        </section>
      )}
      <section className={styles['form-container']}>{children}</section>
      <button
        className={styles['close-modal-button']}
        onClick={modal.close_modal}
      >
        <NextImageV2
          src={modal_content.icon.path}
          height={24}
          width={24}
          alt={modal_content.icon.alt_text}
          quality={100}
        />
      </button>
    </div>
  );
}

export default VehicleModalLayoutCmp;
